import { cn } from '@/lib/utils';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={cn("rounded-lg sm:rounded-xl border bg-white text-gray-950 shadow-sm sm:shadow-md transition-shadow duration-200", className)}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: CardProps) {
  return (
    <div className={cn("flex flex-col space-y-2 sm:space-y-1.5 p-4 sm:p-6", className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className }: CardProps) {
  return (
    <h3 className={cn("text-xl sm:text-2xl font-semibold leading-tight sm:leading-none tracking-tight", className)}>
      {children}
    </h3>
  );
}

export function CardDescription({ children, className }: CardProps) {
  return (
    <p className={cn("text-sm sm:text-sm text-gray-500 leading-relaxed sm:leading-normal", className)}>
      {children}
    </p>
  );
}

export function CardContent({ children, className }: CardProps) {
  return (
    <div className={cn("p-4 sm:p-6 pt-0", className)}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className }: CardProps) {
  return (
    <div className={cn("flex items-center p-4 sm:p-6 pt-0", className)}>
      {children}
    </div>
  );
}